import axios from 'axios';

const namAxios = axios.create();

export function getNamConfig() {
    const baseURL = (window.env?.REACT_APP_NAM_BASEURL || process.env.REACT_APP_NAM_BASEURL || '').trim().replace(/\/+$/, '');
    const scopes = (window.env?.REACT_APP_NAM_SCOPES || process.env.REACT_APP_NAM_SCOPES || '').trim().split(/\s+/).filter(Boolean);
    return { baseURL, scopes, configured: Boolean(baseURL && scopes.length) };
}

export async function acquireNamToken(instance, account, interactive = false, forceRefresh = false) {
    const config = getNamConfig();
    if (!config.configured) {
        throw new Error('Configure REACT_APP_NAM_BASEURL and REACT_APP_NAM_SCOPES to enable NAM address search.');
    }
    if (!account) {
        throw new Error('Sign in before using NAM address search.');
    }
    const request = { account, scopes: config.scopes };
    if (forceRefresh) request.forceRefresh = true;
    const response = await (interactive ? instance.acquireTokenPopup(request) : instance.acquireTokenSilent(request));
    if (!response.accessToken) {
        throw new Error('Entra did not return a NAM access token.');
    }
    return response.accessToken;
}

async function requestNam(instance, account, signal, request) {
    const token = await acquireNamToken(instance, account);
    const send = token => namAxios.request({
        ...request,
        baseURL: getNamConfig().baseURL,
        signal,
        headers: { Authorization: `Bearer ${token}` }
    });
    if (signal?.aborted) throw new axios.CanceledError();
    try {
        return await send(token);
    } catch (error) {
        if (error.response?.status !== 401 || signal?.aborted) throw error;
        const refreshedToken = await acquireNamToken(instance, account, false, true);
        if (signal?.aborted) throw new axios.CanceledError();
        return send(refreshedToken);
    }
}

export async function fetchNamSuggestions(instance, account, query, signal) {
    const response = await requestNam(instance, account, signal, {
        method: 'get',
        url: '/api/v2/address/autocomplete',
        params: { q: query, showCaretPosition: true, numberOfSuggestions: 50 }
    });
    if (!Array.isArray(response.data) || response.data.some(item => !item || typeof item.text !== 'string')) {
        throw new Error('NAM returned an invalid autocomplete response.');
    }
    return response.data.filter(item => item.text);
}
